module.exports = __webpack_public_path__ + "static/media/recipe-app.d62c3a93.JPG";